import { render, staticRenderFns } from "./Brief.vue?vue&type=template&id=aa4b6c1e&scoped=true"
import script from "./Brief.vue?vue&type=script&lang=ts"
export * from "./Brief.vue?vue&type=script&lang=ts"
import style0 from "./Brief.vue?vue&type=style&index=0&id=aa4b6c1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4b6c1e",
  null
  
)

export default component.exports